export const customTagStringToNumber = (string) => {
    switch (string) {
        case '스트리머':
            return 1;
        case '협곡':
            return 2;
        case '칼바람':
            return 3;
        case '빡겜':
            return 4;
        case '즐겜':
            return 5;
        case '친목':
            return 6;
        case '10대':
            return 7;
        case '20대':
            return 8;
        case '30대':
            return 9;
        case '40대':
            return 10;
        case '50대':
            return 11;
        default:
            return 0
    }
}


export const customTagNumberToString = (number) => {
    switch (number) {
        case 1:
            return '방송';
        case 2:
            return '협곡';
        case 3:
            return '칼바';
        case 4:
            return '빡겜'
        case 5:
            return '즐겜';
        case 6:
            return '친목';
        case 7:
            return '10대';
        case 8:
            return '20대';
        case 9:
            return '30대';
        case 10:
            return '40대';
        case 11:
            return '50대';
        default:
            return number
    }
}

export const serverTypeToString = (number) => {
    switch (number) {
        case 1:
            return {
                title: '클랜',
                img: 'icon_tag_shield.svg'
            }
        case 2:
            return {
                title: "크루",
                img: "icon_tag_crew.svg"
            }
        case 3:
            return {
                title: '스트리머',
                img: "icon_tag_streamer.svg"
            }
        default:
            return {
                title: "",
                img: ""
            }
    }
}